import React from 'react';
import i18n from 'react-intl-universal';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Checkbox from '@material-ui/core/Checkbox';

export default ({ ...props }) => {
  const { classes, onChangeTpvView } = props;

  return (
    <List component="div" disablePadding>
      <Divider />
      <ListItem className={classes.nested}>
        <ListItemText
          primary={
            <Typography noWrap={true}>
              {i18n.get('app.dashboard.sidebar.tpvView.agentWithTrasaction')}
            </Typography>
          }
        />
        <ListItemIcon>
          <Checkbox
            checked={props.filteringStateWithAgent}
            onChange={() =>
              onChangeTpvView(
                props.setTpvViewAgentWithTransaction,
                !props.filteringStateWithAgent
              )
            }
            value="agent with transaction"
          />
        </ListItemIcon>
      </ListItem>
      <Divider />
      <ListItem className={classes.nested}>
        <ListItemText
          primary={
            <Typography noWrap={true}>
              {i18n.get('app.dashboard.sidebar.tpvView.leadingAgents')}
            </Typography>
          }
        />
        <ListItemIcon>
          <Checkbox
            checked={props.filteringStateLeadingAgents}
            onChange={() =>
              onChangeTpvView(
                props.setTpvViewLeadingAgents,
                !props.filteringStateLeadingAgents
              )
            }
            value="leading Agent"
          />
        </ListItemIcon>
      </ListItem>
      <Divider />
      <ListItem className={classes.nested}>
        <ListItemText
          primary={
            <Typography noWrap={true}>
              {i18n.get('app.dashboard.sidebar.tpvView.leadingAgentTpv')}
            </Typography>
          }
        />
        <ListItemIcon>
          <Checkbox
            checked={props.filteringStateLeadingAgentTpv}
            onChange={() =>
              onChangeTpvView(
                props.setTpvViewLeadingAgentTpv,
                !props.filteringStateLeadingAgentTpv
              )
            }
            value="leading Agent TPV"
          />
        </ListItemIcon>
      </ListItem>
      <Divider />
      <ListItem className={classes.nested}>
        <ListItemText
          primary={
            <Typography noWrap={true}>
              {i18n.get('app.dashboard.sidebar.tpvView.leadingAgentCategory')}
            </Typography>
          }
        />
        <ListItemIcon>
          <Checkbox
            checked={props.filteringStateLeadingAgentCategory}
            onChange={() =>
              onChangeTpvView(
                props.setTpvViewLeadingAgentCategory,
                !props.filteringStateLeadingAgentCategory
              )
            }
            value="leading Agent Category"
          />
        </ListItemIcon>
      </ListItem>
      <Divider />
      <ListItem className={classes.nested}>
        <ListItemText
          primary={
            <Typography noWrap={true}>
              {i18n.get('app.dashboard.sidebar.tpvView.milkingAgent')}
            </Typography>
          }
        />
        <ListItemIcon>
          <Checkbox
            checked={props.filteringStateMilkingAgent}
            onChange={() =>
              onChangeTpvView(
                props.setTpvViewMilkingAgentCategory,
                !props.filteringStateMilkingAgent
              )
            }
            value="Milking Agent"
          />
        </ListItemIcon>
      </ListItem>
    </List>
  );
};
